/** Day / night toggle — same storage key as owlex.xyz (`owlex-theme`). */

const STORAGE_KEY = "owlex-theme";

let appKitModal = null;

export function registerAppKitModal(modal) {
  appKitModal = modal;
  syncAppKitTheme();
}

function syncAppKitTheme() {
  if (!appKitModal) return;
  const isNight = document.documentElement.getAttribute("data-theme") === "night";
  appKitModal.setThemeMode(isNight ? "dark" : "light");
}

export function initThemeLamp() {
  const html = document.documentElement;
  const lamp = document.getElementById("lamp-pull");
  const metaTheme = document.querySelector('meta[name="theme-color"]');
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  function applyTheme(mode) {
    if (mode === "night") {
      html.setAttribute("data-theme", "night");
    } else {
      html.removeAttribute("data-theme");
    }
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      void e;
    }
    if (lamp) {
      lamp.setAttribute("aria-pressed", mode === "night" ? "true" : "false");
      lamp.setAttribute(
        "aria-label",
        mode === "night" ? "Switch to day mode" : "Switch to night mode"
      );
    }
    if (metaTheme) {
      metaTheme.setAttribute(
        "content",
        mode === "night" ? "#0c0f14" : "#f4f6f9"
      );
    }
    syncAppKitTheme();
  }

  let stored = null;
  try {
    stored = localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    void e;
  }
  if (stored === "night") {
    applyTheme("night");
  }

  lamp?.addEventListener("click", () => {
    const isNight = html.getAttribute("data-theme") === "night";
    const next = isNight ? "day" : "night";
    if (!prefersReducedMotion) {
      lamp.classList.add("lamp-pull--pulling");
      window.setTimeout(() => {
        lamp.classList.remove("lamp-pull--pulling");
      }, 480);
    }
    applyTheme(next);
  });
}
